export const blockIconsCommunicationPowerSettingsNewNew = (
	<span className='material-symbols-outlined'>power_settings_new</span>
);
